var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4166 9.16536C12.1901 9.16536 12.932 8.85807 13.479 8.31109C14.026 7.76411 14.3333 7.02225 14.3333 6.2487C14.3333 5.47515 14.026 4.73328 13.479 4.1863C12.932 3.63932 12.1901 3.33203 11.4166 3.33203M11.1191 16.6654H3.38075C2.52575 16.6654 1.83325 16.0262 1.83325 15.237C1.83325 13.2645 3.56575 11.6654 5.70242 11.6654H8.79742C9.62583 11.6624 10.4356 11.9115 11.1191 12.3795M15.9999 11.6654V16.6654M18.4999 14.1654H13.4999M10.1666 6.2487C10.1666 7.02225 9.85929 7.76411 9.31231 8.31109C8.76533 8.85807 8.02347 9.16536 7.24992 9.16536C6.47637 9.16536 5.73451 8.85807 5.18752 8.31109C4.64054 7.76411 4.33325 7.02225 4.33325 6.2487C4.33325 5.47515 4.64054 4.73328 5.18752 4.1863C5.73451 3.63932 6.47637 3.33203 7.24992 3.33203C8.02347 3.33203 8.76533 3.63932 9.31231 4.1863C9.85929 4.73328 10.1666 5.47515 10.1666 6.2487Z",
    stroke: "#002E6E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/Request.c03d2e8570377462dc68d85ecd843746.svg";
export { ForwardRef as ReactComponent };